export default __webpack_public_path__ + "static/media/unit-result-5.2d4345a8.mp3";